webpackJsonp([55],{

/***/ "V7aM":
/***/ (function(module, exports, __webpack_require__) {

var SectionVideoGallery = (function () {
    function SectionVideoGallery() {
    }
    return SectionVideoGallery;
}());
angular.module('animatronApp.sectionVideoGallery', []).component('sectionVideoGallery', {
    bindings: {
        ltTitle: '<',
        description: '<',
        videos: '<',
        buttons: '<'
    },
    controller: SectionVideoGallery,
    templateUrl: __webpack_require__("lU18")
});


/***/ }),

/***/ "lU18":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/section-video-gallery_311c6de62f4d343d596817287272d2ee.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/55-28dc41a6a889e793a2e2.min.js